// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_5d67af8","slideImage":"_9942234","pagination":"_3da1547"};